export const PDF = "pdf";
export const JPG = "jpg";
